import React from "react";
import styled from "styled-components";

const Container = styled.header`
  padding: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.11);
`;

const HeaderLogo = styled.img`
  width: 105px;
  height: 100%;
`;

function Logo() {
  return (
    <Container>
      <HeaderLogo
        alt="Cigna Logo"
        src="https://static.cigna.com/spa/my-cigna/assets/images/cigna-logo.svg"
      />
    </Container>
  );
}

export default Logo;
